<div id="top-ten-container">

  <div id="top-five-label-container">
    <label *ngIf="haveResult">Top routes for last 3 hours (last update {{lastUpdateTime}})</label>
    <label *ngIf="!haveResult">No routes found</label>
  </div>

  <div class="top-route-grid-container" [hidden]="!haveResult">
    <ag-grid-angular #agGrid
                     [columnDefs]="columnDefs"
                     (selectionChanged)="onSelectionChanged()"
                     style="height: 100%;"
                     class="ag-theme-balham top-route-grid"
                     [gridOptions]="gridOptions">
    </ag-grid-angular>
  </div>

  <divider [title]="'Route details'" [hidden]="!haveResult || !topRoutePathSelected"></divider>

  <div *ngIf="topRoutePathSelected" id="top-ten-routing-rule-details" [hidden]="!haveResult">
    <span class="top-ten-route-details-field">Route: </span><span class="top-ten-route-details-value"> {{topRoutePathSelected.route}}</span>
    <br>
    <span class="top-ten-route-details-field">Source node: </span><span class="top-ten-route-details-value"> {{topRoutePathSelected.srcNodeName}}</span>
    <br>
    <span class="top-ten-route-details-field">Source PCon: </span><span class="top-ten-route-details-value"> {{topRoutePathSelected.srcPeerConnectionName}}</span>
    <br>
    <span class="top-ten-route-details-field">Destination node: </span><span class="top-ten-route-details-value">  {{topRoutePathSelected.destNodeName}}</span>
    <br>
    <span class="top-ten-route-details-field">Destination PCon: </span><span class="top-ten-route-details-value"> {{topRoutePathSelected.destPeerConnectionName}}</span>
    <br>
    <span class="top-ten-route-details-field">Num of hits: </span><span class="top-ten-route-details-value"> {{topRoutePathSelected.hits}}</span>
    <br>
  </div>

  <div id="top-routes-buttons-container" *ngIf="haveResult">
    <ac-button mat-raised-button color="primary" type="button" class="search-button"
            [ngDisabled]="topRoutePathSelected === null || !topRoutePathSelected"
            (click)="removeSelection()">Clear
    </ac-button>
  </div>
</div>
